export default function wrapInlineTables (value) {
	value = value.toString();
	value = value.replace(/(<table)/g, '<div class="inline-table-wrapper"><table');
	value = value.replace(/(<\/table>)/g, '</table></div>');
	return value;
}